import { useState, useEffect } from "react";
import { AlertColor } from "@mui/material";

const useSnackbar = (duration: number = 6000) => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<
    AlertColor | undefined
  >("info");
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    if (!openSnackbar) return;

    const interval = 100;
    const decrement = 100 / (duration / interval);

    const timer = setInterval(() => {
      setProgress((prev) => Math.max(prev - decrement, 0));
    }, interval);

    return () => clearInterval(timer);
  }, [openSnackbar, duration]);

  return {
    openSnackbar,
    snackbarMessage,
    snackbarSeverity,
    progress,
    setOpenSnackbar,
    setSnackbarMessage,
    setSnackbarSeverity,
    setProgress,
    duration,
  };
};

export default useSnackbar;
